import { apiService } from './api.service';
import { AcademicPlan } from '../types';

export const planService = {
  getPlans: async (): Promise<AcademicPlan[]> => {
    return apiService.get<AcademicPlan[]>('/api/v1/plans/');
  },

  getPlan: async (id: number): Promise<AcademicPlan> => {
    return apiService.get<AcademicPlan>(`/api/v1/plans/${id}`);
  },

  createPlan: async (name: string, description?: string): Promise<AcademicPlan> => {
    return apiService.post<AcademicPlan>('/api/v1/plans/', { name, description });
  },

  deletePlan: async (id: number): Promise<void> => {
    return apiService.delete(`/api/v1/plans/${id}`);
  }
};
